<template>
    <div>
        <div class="white-box">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isLoadingData" />
                <div
                    v-else
                    class="divide-y divide-gray-200"
                >
                    <ul class="text-tip">
                        <li>申請新台幣貨幣帳戶定期定額投資金額轉換，請同時填寫指定轉換日，且帳戶價值應有新台幣貨幣帳戶金額。</li>
                    </ul>
                    <Frame
                        v-model:isOpen="isOpenInvest"
                        title="投資設定"
                        button-position="mt-2.5 md:mt-3.5"
                        class="border-b border-gray-200"
                        @resetValues="cancelInvest"
                    >
                        <template #data>
                            <div class="text-gray-700">
                                <div class="user-data-text">
                                    <p>新台幣貨幣帳戶預估現值</p>
                                    <p>{{ addComma(showData.nt02Pv) }}</p>
                                </div>
                                <div class="user-data-text">
                                    <p>投資金額</p>
                                    <p>{{ addComma(showData.amount) }}</p>
                                </div>
                                <div class="user-data-text">
                                    <p>指定轉換日</p>
                                    <p>
                                        <template v-if="!showData.nt02Date">
                                            未指定
                                        </template>
                                        <template v-else>
                                            每月{{ showData.nt02Date >= 10 ? showData.nt02Date : '0' + showData.nt02Date }}日
                                        </template>
                                    </p>
                                </div>
                                <div
                                    v-if="showData.closeCode"
                                    class="w-full pb-2.5 text-sm md:text-lg"
                                    :class="{'border-b border-dashed border-gray-100':!isOpenInvest}"
                                >
                                    <p>
                                        若因辦理變更或基金交易中，致無法於指定轉換日進行轉換時，
                                        {{ showData.closeCode=== '1' ? '將於變更或交易完成後之次一工作日，始進行轉換。': '' }}
                                        {{ showData.closeCode=== '2' ? '將取消當月投資標的轉換，但不計入失敗次數。': '' }}
                                    </p>
                                </div>
                            </div>
                        </template>
                        <template #inputs>
                            <div class="lg:flex py-3.5 first:pt-0">
                                <div class="flex justify-start lg:w-7/12 pb-3.5 lg:pb-0 mt-6 lg:mt-0">
                                    <label class="w-1/3 lg:w-auto lg:mr-1  label-base label-text">投資金額</label>
                                    <div class="w-full max-w-[15.625rem] lg:max-w-[12.25rem] relative">
                                        <input
                                            v-model.number="userData.amount"
                                            placeholder="請輸入投資金額"
                                            type="text"
                                            class="input-base w-full "
                                            inputmode="numeric"
                                            autocomplete="off"
                                            maxlength="7"
                                            :disabled="isCancelService"
                                            @input="validateAmount"
                                        >
                                        <p class="text-error text-right">
                                            {{ userData.errorMessage.amount }}
                                        </p>
                                        <ul class="text-tip mb-0 xs:leading-7 md:leading-[3rem] tips-position">
                                            <li class="text-sm mb-0">
                                                至少{{ addComma(showData.amountMin) }}元
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="flex justify-start pt-3.5 lg:pt-0 lg:w-5/12 border-top lg:border-0">
                                    <label class="w-1/3 lg:w-auto lg:mr-1 label-base label-text">指定轉換日</label>
                                    <div class="w-full max-w-[15.625rem]">
                                        <Multiselect
                                            v-model="userData.nt02Date"
                                            :options="dateArr"
                                            class="select-base"
                                            placeholder="請選擇指定轉換日"
                                            :can-clear="false"
                                            :can-deselect="false"
                                            :disabled="isCancelService"
                                            @select="userData.errorMessage.nt02Date =''"
                                        />
                                        <p class="text-error text-right">
                                            {{ userData.errorMessage.nt02Date }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full py-3.5 lg:pt-0 border-top lg:border-0">
                                <div class="text-base md:text-lg pb-1">
                                    若因辦理變更或基金交易中，致無法於指定轉換日進行轉換時，本人同意
                                </div>
                                <div class="w-full max-w-[25.1rem]">
                                    <Radio
                                        v-model:checkedValue="userData.closeCode"
                                        :disabled="isCancelService"
                                        value="1"
                                        text="於作業完成後之次一工作日，始進行轉換。"
                                        class="items-baseline mb-0 mr-0 pb-1"
                                        textClass="text-base md:text-lg"
                                        @input="userData.errorMessage.closeCode = ''"
                                    />
                                    <Radio
                                        v-model:checkedValue="userData.closeCode"
                                        :disabled="isCancelService"
                                        value="2"
                                        text="將取消當月投資標的轉換，但不計入失敗次數。"
                                        class="items-baseline mb-0 mr-0 pb-1"
                                        textClass="text-base md:text-lg"
                                        @input="userData.errorMessage.closeCode = ''"
                                    />
                                    <p class="text-error text-right">
                                        {{ userData.errorMessage.closeCode }}
                                    </p>
                                </div>
                            </div>
                            <div class="pt-3.5 border-top">
                                <!-- 資料庫無投資標的即未申請過 -->
                                <Checkbox
                                    v-if="showData.nt02ReinvestList.length!==0"
                                    v-model:checkedValues="isCancelService"
                                    :value="true"
                                    text="終止新台幣貨幣帳戶定期定額轉換"
                                    class="items-baseline mb-0 mr-0"
                                    @input="clearAllErrMsg"
                                />
                            </div>
                        </template>
                    </Frame>
                    <!-- 配置比例 -->
                    <div
                        v-if="!isCancelService"
                        class="pb-2"
                    >
                        <Frame
                            v-model:isOpen="isOpenPercent"
                            title="配置比例"
                            button-position="mt-2.5"
                            @resetValues="cancelPercent"
                        >
                            <template #data>
                                <CustomTable
                                    :is-border="false"
                                    :cursor-pointer="false"
                                    class="xs:text-lg"
                                >
                                    <template #thead>
                                        <tr class="hidden md:table-row">
                                            <td class="flex justify-between">
                                                <p>標的名稱</p>
                                                <p class="w-1/5 flex-shrink-0 px-3">
                                                    比例
                                                </p>
                                            </td>
                                        </tr>
                                    </template>
                                    <template #tbody>
                                        <tr
                                            v-for="(item, index) in showData.nt02ReinvestList"
                                            :key="index"
                                            class="even:bg-white"
                                        >
                                            <td>
                                                <div class="flex justify-between">
                                                    <div>
                                                        {{ `${item.fundCode} ${item.fundName}` }}
                                                    </div>
                                                    <div class="w-1/5 flex-shrink-0 px-3">
                                                        {{ item.percent }}%
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="item.fundMsg.length>0"
                                                    class="bg-gray-50 px-2.5 py-1.5 md:py-2.5 text-warning text-sm xs:text-base mt-2.5"
                                                >
                                                    {{ item.fundMsg }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </CustomTable>
                                <Nodata
                                    v-if="showData.nt02ReinvestList.length===0"
                                    class="md:mt-3 mb-0"
                                >
                                    系統無資料
                                </Nodata>
                            </template>
                            <template #inputs>
                                <BankFundForm
                                    v-model:validInput="validInput"
                                    v-model:subtotal="subtotal"
                                    :dataBase="showData.nt02ReinvestList"
                                    :data="userData.nt02ReinvestList"
                                    :bankList="bankList"
                                    :fundBankList="fundBankList"
                                    autoAddRow
                                    class="border-b border-solid"
                                    @getValidResult="getValidResult"
                                />
                            </template>
                        </Frame>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template #top>
                <div class="text-xs py-1">
                    剩餘可分配比例：
                </div>
                <div class="text-base xs:text-lg py-1">
                    {{ subtotal }}%
                </div>
            </template>
            <template #center>
                <div class="text-base py-2.5">
                    剩餘可分配比例： {{ subtotal }}%
                </div>
            </template>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="!hasChangeData"
                    @click="validGoNext"
                />
            </template>
        </Bottombar>
        <Loading :is-loading="isLoading" />
    </div>
</template>

<script>
import { computed, inject, reactive, toRefs, ref } from 'vue';
import { makeSort } from '@/utils/array/makeSort';
import { getInfoA9, getFundBankInfoA9, submitA9 } from '@/apis/A9';
import { addComma } from '@/utils/number/addComma';
import { intMinMax } from '@/utils/rules/customRules';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Checkbox from '@/components/checkboxs/Checkbox.vue';
import Radio from '@/components/radios/Radio.vue';
import CustomTable from '@/components/table/Table.vue';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import Frame from '@/components/collapse/CollapseFrame.vue';
import BankFundForm from '@/components/template/bankFund/BankFundForm.vue';
import dialogContnet from '@/json/dialogContent.js';
import Multiselect from '@vueform/multiselect';
import Skeletons from './Skeletons.vue';
import Loading from '@/components/Loading.vue';
import Nodata from '@/components/text/EmptyData.vue';
import _ from 'lodash';

export default {
    components: {
        Frame,
        Checkbox,
        CustomTable,
        BankFundForm,
        ButtonNextService,
        Bottombar,
        Multiselect,
        Skeletons,
        Loading,
        Nodata,
        Radio
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const route = useRoute();
        const { code } = route.meta;
        const state = reactive({
            isOpenInvest: false,
            isOpenPercent: false,
            isSubmitOk: false,
            isLoading: false,
            isLoadingData: false,
            validInput: false,
        });
        const data = reactive({
            bankList: [],
            fundBankList: [],
            subtotal: 0,
            showData: {}, // 顯示資料
            userData: { // 使用者資料
                amount: 0,
                nt02Date: 0,
                closeCode: '',
                nt02ReinvestList: [],
                errorMessage: {
                    amount: '',
                    nt02Date: '',
                    closeCode: '',
                }
            },
        });
        const isCancelService = ref(false);
        const result = computed(() => {
            const vuexData = store.state.services.changeItemsResult[code];
            return vuexData ? _.cloneDeep(vuexData) : undefined;
        });

        const dateArr = computed(() => {
            const arr = [];
            for (let i = 1; i <= 31; i++) {
                const obj = {};
                obj.value = i;
                const date = i < 10 ? '0' + i : i;
                obj.label = `每月${date}日`;
                arr.push(obj);
            }
            return arr;
        });

        /** 重設配置比例資料 */
        const resetForm = (baseList) => {
            const arr = _.cloneDeep(baseList);
            return arr.map(i => {
                i.dbData = true;
                i.errorMessage = {};
                if (i.disableType === 3) {
                    i.maxPercent = i.percent;
                }
                if (i.disableType === 0 || i.disableType === 2) {
                    i.disabledPercent = true;
                }
                return i;
            });
        };

        /** 取得頁面資料 */
        const getData = async () => {
            state.isLoadingData = true;
            /** 投資標的公司及投資標的名稱下拉式選單資料 */
            await getFundBankInfoA9().then(res => {
                data.bankList = res.data.bankList.map(i => {
                    i.value = i.bankNo;
                    return i;
                });
                data.fundBankList = res.data.fundBankList.map(i => {
                    i.value = i.fundCode;
                    i.label = `${i.fundCode} ${i.fundName} (${i.fundTypeCH})`;
                    return i;
                });
            });

            /** user資料 */
            getInfoA9().then((res) => {
                if (res.data) {
                    data.showData = _.cloneDeep(res.data);
                    const key = Object.keys(res.data);
                    const userDatakey = Object.keys(data.userData);
                    key.forEach(i => {
                        if (userDatakey.findIndex(j => i === j) !== -1) {
                            if (i === 'nt02ReinvestList') {
                                data.userData[i] = resetForm(res.data[i]);
                            } else {
                                data.userData[i] = res.data[i];
                            }
                        }
                    });
                }
            }).finally(() => {
                state.isLoadingData = false;
            });
        };
        if (!result.value) {
            getData();
        } else {
            const {
                storeFundBankList,
                storeShowData,
                storeBankList,
                storeUserData,
                storeIsOpenInvest,
                storeIsOpenPercent,
                storeterminate
            } = result.value;
            data.bankList = storeBankList;
            data.fundBankList = storeFundBankList;
            data.showData = _.cloneDeep(storeShowData);
            data.userData = _.cloneDeep(storeUserData);
            isCancelService.value = storeterminate;
            state.isOpenInvest = storeIsOpenInvest;
            state.isOpenPercent = storeIsOpenPercent;
        }

        const validateAmount = (event) => {
            const amountMin = data.showData.amountMin;
            const amountMax = data.showData.nt02Pv;
            const { val, errorMessage } = intMinMax({
                value: event.target.value,
                minNum: amountMin,
                maxNum: amountMax,
                type: 2,
                minMsg: `投資金額須大於${addComma(amountMin)}元`,
                maxMsg: '投資金額須小於預估現值',
            });
            data.userData.errorMessage.amount = errorMessage;
            event.target.value = val;
        };

        /** 取消變更-投資設定 */
        const cancelInvest = () => {
            data.userData.amount = data.showData.amount;
            data.userData.nt02Date = data.showData.nt02Date;
            data.userData.closeCode = data.showData.closeCode;
            clearInvestErrMsg();
        };

        /** 取消變更配置比例 */
        const cancelPercent = () => {
            data.userData.nt02ReinvestList = resetForm(data.showData.nt02ReinvestList);
            clearPercentErrMsg();
        };

        /** 勾選取消申請，清除所有錯誤訊息 */
        const clearAllErrMsg = () => {
            if (isCancelService.value) {
                clearInvestErrMsg();
                clearPercentErrMsg();
            }
        };

        /** 清除投資設定錯誤訊息 */
        const clearInvestErrMsg = () => {
            data.userData.errorMessage.amount = '';
            data.userData.errorMessage.nt02Date = '';
            data.userData.errorMessage.closeCode = '';
        };

        /** 清除配置比例錯誤訊息 */
        const clearPercentErrMsg = () => {
            data.userData.nt02ReinvestList.forEach(i => {
                i.errorMessage.bankNo = '';
                i.errorMessage.fundCode = '';
                i.errorMessage.percent = '';
            });
        };

        /** 製作只有fundCode percent 物件的陣列 */
        const makeArray = (array) => {
            if (array) {
                const list = array.map(i => {
                    return {
                        fundCode: i.fundCode,
                        percent: i.percent
                    };
                });
                return list;
            }
        };

        const makeDataArray = (dataObj, examItem) => {
            const otherData = [];
            const dataKey = Object.keys(dataObj);
            dataKey.forEach(i => {
                if (examItem.findIndex(j => i === j) !== -1) {
                    otherData.push(dataObj[i]);
                }
            });
            return otherData;
        };

        /** 資料異動檢查 */
        const hasChangeData = computed(() => {
            let hasChangeData = false;
            if (isCancelService.value) {
                hasChangeData = true;
            } else {
                let showList = makeArray(data.showData.nt02ReinvestList);
                let userList = makeArray(data.userData.nt02ReinvestList);
                if (showList) showList = makeSort(showList, 'fundCode');
                if (userList) userList = makeSort(userList, 'fundCode');
                const examItem = ['amount', 'nt02Date', 'closeCode'];
                const showDataOtherData = makeDataArray(data.showData, examItem);
                const userDataOtherData = makeDataArray(data.userData, examItem);
                const dbData = `${JSON.stringify(showDataOtherData)}${JSON.stringify(showList)}`;
                const changeData = `${JSON.stringify(userDataOtherData)}${JSON.stringify(userList)}`;
                hasChangeData = dbData !== changeData;
            }

            return hasChangeData;
        });

        /** 下一步 檢查錯誤與是否有修改資料 */
        const validGoNext = () => {
            if (hasChangeData.value) {
                /** 未勾選終止申請，繼續檢查其他欄位 */
                if (!isCancelService.value) {
                    state.validInput = true;
                } else {
                    submit();
                }
            }
        };

        const getValidResult = (hasFormError, list) => {
            // hasFormError=false ,繼續檢查其他欄位
            let hasErrorData = hasFormError;
            let params = null;
            if (!hasErrorData) {
                /* 如果有打開變更才檢查 */
                if (state.isOpenInvest) {
                    // 確認input是否為空
                    const { amount, nt02Date, closeCode, errorMessage } = data.userData;
                    if (!amount) data.userData.errorMessage.amount = '請輸入投資金額';
                    if (!nt02Date) data.userData.errorMessage.nt02Date = '請選擇指定轉換日';
                    if (!closeCode) data.userData.errorMessage.closeCode = '請選擇轉換補轉';

                    hasErrorData = Object.values(errorMessage).some(i => i !== '');
                    if (hasErrorData) {
                        params = dialogContnet.validateMsg;
                        modalShow(params);
                    } else {
                        submit(list);
                    }
                } else if (!data.showData.nt02ReinvestList.length) {
                    params = {
                        title: '提示',
                        content: '請輸入投資金額，指定轉換日並選擇轉換補轉。',
                        confirmButton: '確認',
                        cancelButton: null,
                        closeicon: true,
                    };
                    modalShow(params);
                } else {
                    submit(list);
                }
            }
        };

        const submit = (datalist) => {
            state.isLoading = true;
            const { amount, nt02Date, closeCode } = data.userData;
            const returnData = {
                amount: null,
                nt02Date: null,
                closeCode: null,
                nt02ReinvestList: [],
                terminate: false
            };
            if (isCancelService.value) {
                returnData.terminate = isCancelService.value;
            } else {
                returnData.amount = amount;
                returnData.nt02Date = nt02Date;
                returnData.closeCode = closeCode;
                returnData.nt02ReinvestList = makeArray(datalist);
            }
            submitA9(returnData).then((res) => {
                const list = {
                    storeBankList: data.bankList,
                    storeFundBankList: data.fundBankList,
                    storeShowData: data.showData,
                    storeUserData: data.userData,
                    storeterminate: isCancelService.value,
                    storeIsOpenInvest: state.isOpenInvest,
                    storeIsOpenPercent: state.isOpenPercent,
                };
                store.dispatch('services/setChangeItemsResult', { code, value: list });
                state.isSubmitOk = true;
            }).finally(() => {
                state.isLoading = false;
            });
        };

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            isCancelService,
            addComma,
            hasChangeData,
            validGoNext,
            validateAmount,
            clearAllErrMsg,
            cancelInvest,
            cancelPercent,
            getValidResult,
            dateArr
        };
    }
};
</script>
<style lang="scss" scoped>
.user-data-text {
    @apply flex justify-between pb-2.5 mb-2.5 border-b border-dashed border-gray-100 md:w-1/2;
}
label.label-lineHight {
    @apply leading-6 xs:leading-7 md:leading-[3rem];
}
.label-text {
    @apply flex-shrink-0 text-sm md:text-base lg:text-lg text-gray-900 max-w-[5.825rem];
}
.border-top {
    @apply border-t border-dashed border-gray-100;
}
.tips-position {
    @apply absolute top-[-1.35rem] lg:top-[0.875rem] lg:right-[-0.5rem] lg:translate-x-full;
}
</style>
